// The three windows around reading that a campaign chooses when it's
// planned. Defaults mirror Campaign (donation_lead_days,
// minute_logging_days, donation_days_after).

// donation_lead_days: null means donations open any time before reading.
export const WINDOW_DEFAULTS = { donation_lead_days: null, minute_logging_days: 1, donation_days_after: 7 };

// Suggested when a school switches to opening donations a set number of
// days before reading.
export const SUGGESTED_LEAD_DAYS = 14;
